import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Link from "@airasia/phoenix-components/components/Link"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"

const StyledText = styled.div`
  margin-bottom: 15px;
`

StyledText.displayName = "StyledText"

const LinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`

LinkContainer.displayName = "LinkContainer"

const LinkDiv = styled.div`
  width: ${props => props.linkWidth};
  margin: 10px 0px;
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`

LinkDiv.displayName = "LinkDiv"

const InternalLinkingMerchant = props => {
  const {
    linkObjects,
    linkWidth,
    blockTitle,
    blockDescription,
    accessible,
    linkSize,
    linkColor,
    linkHoverColor,
    linkHoverUnderlined,
    linkUnderlined,
    linkTarget,
    blockTitleType,
    descriptionTextColor,
  } = props

  const linkProps = {
    accessible,
    color: linkColor,
    size: linkSize,
    hoverColor: linkHoverColor,
    hoverUnderlined: linkHoverUnderlined,
    target: linkTarget,
    underlined: linkUnderlined,
  }

  const titleProps = {
    accessible,
    type: blockTitleType,
  }

  const [links] = useState(linkObjects)
  //  console.log("linkObjects",linkObjects)
  //  console.log("links",links)

  return (
    <div>
      {blockTitle && (
        <StyledText>
          <Title {...titleProps}>{blockTitle}</Title>
        </StyledText>
      )}
      {blockDescription && (
        <StyledText>
          <Text accessible color={descriptionTextColor}>
            {blockDescription}
          </Text>
        </StyledText>
      )}
      <LinkContainer>
        {links.map(value => {
          return (
            <LinkDiv key={value.label} linkWidth={linkWidth}>
              <div style={{ margin: "0px 10px 0px 10px" }}>
                <Link href={value.href} {...linkProps}>
                  {value.label}
                </Link>
              </div>
            </LinkDiv>
          )
        })}
      </LinkContainer>
    </div>
  )
}

InternalLinkingMerchant.propTypes = {
  linkObjects: PropTypes.arrayOf(PropTypes.object).isRequired,
  blockTitle: PropTypes.string,
  blockDescription: PropTypes.string,
  accessible: PropTypes.bool,

  linkColor: PropTypes.string,
  linkSize: PropTypes.string,
  linkHoverColor: PropTypes.string,
  linkHoverUnderlined: PropTypes.bool,
  linkUnderlined: PropTypes.bool,
  linkTarget: PropTypes.string,

  blockTitleType: PropTypes.string,

  descriptionTextColor: PropTypes.string,
}

InternalLinkingMerchant.defaultProps = {
  accessible: false,

  linkWidth: "25%",
  linkColor: "primary",
  linkSize: "normal",
  linkHoverColor: "neutral",
  linkHoverUnderlined: true,
  linkTarget: "self",

  blockTitleType: "h2",

  descriptionTextColor: "greyDark",
}

export default InternalLinkingMerchant
